import { render } from "./ProfessionalsFunctionality.vue?vue&type=template&id=c2858d30&scoped=true"
import script from "./ProfessionalsFunctionality.vue?vue&type=script&lang=js"
export * from "./ProfessionalsFunctionality.vue?vue&type=script&lang=js"

import "./ProfessionalsFunctionality.vue?vue&type=style&index=0&id=c2858d30&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2858d30"]])

export default __exports__